import config from '../../../configure'

const options = {
  layout: config.layout,
  layoutType: config.layoutType,
  collapseMenu: config.collapseMenu,
  iconColor: config.iconColor,
  menuFixed: config.menuFixed,
  headerFixed: config.fixedHeader,
  boxLayout: config.boxLayout,
  rtl: config.rtl,
  menuDropdownIcon: config.menuDropdownIcon,
  menuListIcon: config.menuListIcon,
  menuActiveColor: config.menuActiveColor,
  menuTitleColor: config.menuTitleColor,
  hideCaption: config.hideCaption,
  headerBreadcrumbHide: config.headerBreadcrumbHide,
  headerBg: config.headerBg,
  brandBg: config.brandBg,
  menuBg: config.menuBg,
  menuBgGradient: config.menuBgGradient,
  menuBgPattern: config.menuBgPattern,
  menuBgImage: config.menuBgImage,
  configBlock: config.configBlock,
  resMenu: false,
  prebuildLayout: config.prebuildLayout,
}


export default options